module.exports = __webpack_public_path__ + "media/images/loading-c2fa0e2b3e33ce4e2481de141be062d5.gif";